import styled from "styled-components";
import { WithStyles } from "@material-ui/core/styles";
import { Modal } from "@material-ui/core";
import theme from "@src/Shared/Tools/SharedMuiTheme";

interface IProps extends WithStyles {
  width: number;
}

export const STModal = styled(Modal)`
  && {
    ${theme.breakpoints.only("xs")} {
      overflow-y: scroll;
    }
  }
`;

export const STWrapperModal = styled.div`
  border-radius: 5px;
  box-sizing: border-box;

  position: absolute;
  min-width: ${(props: IProps) => props.width}px;
  top: 10%;
  left: calc(50vw - (${(props: IProps) => props.width}px / 2));
  background-color: #fff;
  padding: 15px;
  outline: none;

  display: flex;
  justify-content: center;
  align-items: center;

  ${theme.breakpoints.only("xs")} {
    top: 15px;
    min-width: 90%;
    width: 90%;
    left: calc(50% - (90% / 2));
  }

  ${theme.breakpoints.only("sm")} {
    min-width: 400px;
    left: calc(50% - (400px / 2));
  }
`;
